import { Notification } from "@diacare/common/models/notification";
import { EditPage, EditPageHeader, Field, Resource, SaveButton } from "@litbase/admin";
import { Card, FormCardTitle, spacing } from "@litbase/alexandria";
import { HookFieldWrapper } from "@litbase/alexandria/components/hook-form/hook-field-wrapper";
import { useController } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import TextArea from "react-textarea-autosize";
import styled from "styled-components";
import { notificationConfig } from "../models/notification";

export function NotificationEditPage() {
  const navigate = useNavigate();

  return (
    <Resource config={notificationConfig}>
      <Container>
        <EditPage
          // @ts-expect-error
          hideSaveButton
          successMessage={{ title: "Success!", text: "Notification saved successfully." }}
          transformValuesBeforeSubmit={(values) => ({
            ...(values as Notification),
            createdAt: (values as Notification).createdAt || new Date(),
            enabled: (values as Notification).enabled || false,
          })}
          afterSubmit={() => navigate("/notifications")}
        >
          <EditPageHeader<Notification>>
            {(item) => <h1>{item ? "Edit notification" : "Add a new notification"}</h1>}
          </EditPageHeader>
          <Field property="createdAt" hidden />
          <Field property="enabled" hidden />
          <Col>
            <FormCardTitle>
              <Subtitle>Notification details</Subtitle>
            </FormCardTitle>
            <Field property="title" />
            <Field property="descriptionHu">
              <RequiredNotificationTextarea name="descriptionHu" label="Description (Hungarian)" />
            </Field>
            <Field property="descriptionEn">
              <RequiredNotificationTextarea name="descriptionEn" label="Description (English)" />
            </Field>
          </Col>
          <Row>
            <StyledSaveButton />
          </Row>
        </EditPage>
      </Container>
    </Resource>
  );
}

function RequiredNotificationTextarea({ name, label }: { name: "descriptionHu" | "descriptionEn"; label: string }) {
  const controller = useController<Notification>({
    name,
    rules: {
      validate: (value) => (typeof value === "string" && value.trim().length > 0) || "Required field",
    },
  });

  return (
    <HookFieldWrapper name={name} label={label} $fullWidth>
      <StyledTextarea
        minRows={5}
        name={controller.field.name}
        value={controller.field.value || ""}
        onChange={controller.field.onChange}
        onBlur={controller.field.onBlur}
        ref={controller.field.ref}
      />
    </HookFieldWrapper>
  );
}

const StyledSaveButton = styled(SaveButton)`
  margin-left: auto;
`;

const Container = styled.div`
  max-width: 700px;
  margin: 0 auto;
`;

const Col = styled(Card)`
  display: flex;
  flex-direction: column;
  width: 100%;

  button {
    width: fit-content;
  }

  textarea {
    border: 1px solid ${({ theme }) => theme.gray300};
  }
`;

const StyledTextarea = styled(TextArea)`
  padding: ${({ theme }) => theme.spacing3};
  width: 100%;
  border-radius: ${({ theme }) => theme.rounded};
  font-family: ${({ theme }) => theme.fontFamilyBase};
  border: 1px solid ${({ theme }) => theme.gray300};

  ::placeholder {
    font-size: ${({ theme }) => theme.textBase};
  }
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  margin-top: ${spacing._4};
`;

const Subtitle = styled.span``;
